// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"13ed6274","455":"46bf8506"}[chunkId] + ".chunk.js";
};